import { withProcedureWraper } from "../../../../..";

import { CreateApplicationForLeaveForm } from "../../../components";
import ProcedureLayout from "../../../../../../../components/layouts/procedure-layout";

export const isInGroup = (
  codeJobTitle: string, // ex. "CNTT-DTQTCNTT"
  group: string[],
  options?: { splitCharacter?: string },
): Boolean => {
  const codeList: string[] = codeJobTitle.split(options?.splitCharacter ?? "-");
  for (const position of group) {
    const isMatched = codeList.some((e: string) => e.startsWith(position));
    if (isMatched) return true;
  }
  return false;
};

const AbsenceLetterCreate = withProcedureWraper(() => {
  return (
    <ProcedureLayout title="Tạo đơn xin nghỉ phép">
      <CreateApplicationForLeaveForm />
    </ProcedureLayout>
  );
});

export default AbsenceLetterCreate;
